module.exports = __webpack_public_path__ + "static/img/6.a7f15df.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/6.png
// module id = 284
// module chunks = 0